import React from "react";

interface LockIconProps {
  position: [number, number, number];
  scale?: number;
}

/** A simple low-poly padlock built from primitives — marks a project as archived. */
const LockIcon: React.FC<LockIconProps> = ({ position, scale = 1 }) => (
  <group position={position} scale={scale}>
    {/* Shackle (half-torus arc) */}
    <mesh position={[0, 0.16, 0]} rotation={[Math.PI / 2, 0, 0]} castShadow>
      <torusGeometry args={[0.11, 0.028, 8, 16, Math.PI]} />
      <meshStandardMaterial color="#8a8a82" metalness={0.6} roughness={0.4} />
    </mesh>
    {/* Body */}
    <mesh position={[0, 0, 0]} castShadow>
      <boxGeometry args={[0.24, 0.2, 0.12]} />
      <meshStandardMaterial color="#5c5c54" metalness={0.4} roughness={0.5} />
    </mesh>
    {/* Keyhole */}
    <mesh position={[0, 0, 0.065]}>
      <circleGeometry args={[0.028, 8]} />
      <meshStandardMaterial color="#2a2a26" />
    </mesh>
  </group>
);

export default LockIcon;
